<template>
  <section class="login-screen">
    <div class="login-panel">
      <div class="login-brand">
        <div class="login-brand__mark">AC</div>
        <div>
          <p>App Companion</p>
          <span>Inventory Workspace</span>
        </div>
      </div>

      <div class="login-heading">
        <h1>Sign in</h1>
        <p>Inventory, reports and stock control.</p>
      </div>

      <v-form ref="form" v-model="valid" lazy-validation class="login-form" @submit.prevent="handleSubmit">
        <v-text-field
          v-model="username"
          label="Username"
          :rules="nameRules"
          outlined
          autocomplete="username"
          prepend-inner-icon="mdi-account"
        />

        <v-text-field
          v-model="password"
          :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPass ? 'text' : 'password'"
          label="Password"
          :rules="passwordRules"
          outlined
          autocomplete="current-password"
          prepend-inner-icon="mdi-lock"
          @click:append="showPass = !showPass"
        ></v-text-field>

        <v-alert v-if="loginFailed" dense text type="error" class="login-alert">
          Login failed. Check your details and try again.
        </v-alert>

        <v-btn
          type="submit"
          :disabled="!valid || loggingIn"
          :loading="loggingIn"
          color="primary"
          large
          block
        >
          Sign in
        </v-btn>
      </v-form>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      username: '',
      password: '',
      submitted: false,

      showPass: false,
      valid: true,

      nameRules: [
        v => !!v || 'Username is required',
      ],
      passwordRules: [
        v => !!v || 'Password is required',
      ],
    }
  },
  computed: {
    loggingIn () {
      return this.$store.state.status.loggingIn;
    },
    loginFailed () {
      return this.$store.state.status.loginFailed;
    }
  },
  created () {
    this.$store.dispatch('logout');
  },
  methods: {
    handleSubmit () {
      this.$refs.form.validate();

      this.submitted = true;
      const { username, password } = this;
      const { dispatch } = this.$store;

      if (username && password) {
        dispatch('login', { username, password });
      }

      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.login-screen {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
}

.login-panel {
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(203, 213, 225, 0.9);
  border-radius: 8px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.12);
  max-width: 440px;
  padding: 24px;
  width: 100%;
}

.login-brand {
  align-items: center;
  display: flex;
  gap: 12px;
  margin-bottom: 32px;

  p {
    color: #111827;
    font-size: 17px;
    font-weight: 800;
    line-height: 1.1;
    margin: 0;
  }

  span {
    color: #64748b;
    display: block;
    font-size: 12px;
    margin-top: 4px;
  }
}

.login-brand__mark {
  align-items: center;
  background: #0f766e;
  border-radius: 8px;
  color: #fff;
  display: flex;
  font-weight: 800;
  height: 44px;
  justify-content: center;
  width: 44px;
}

.login-heading {
  margin-bottom: 22px;

  h1 {
    color: #111827;
    font-size: 30px;
    font-weight: 800;
    line-height: 1.1;
    margin: 0;
  }

  p {
    color: #64748b;
    font-size: 14px;
    margin: 8px 0 0;
  }
}

.login-form {
  button {
    margin-top: 4px;
  }
}

.login-alert {
  margin-bottom: 18px;
}

@media (min-width: 768px) {
  .login-panel {
    padding: 32px;
  }
}
</style>
